// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_l3-0";